import * as datadog from "@/shared/datadog";
import { useNotifierStore } from "./store/notifier";
import { useUserStore } from "@/shared/store/user";
import _ from "lodash";

const oktaErrorCodesToExcludeFromLog = [
  "E0000004", // Authentication error
  "E0000014", // Update credentials failed error
  "E0000069", // User locked error
  "E0000011" // Invalid token provided. This is handled by sign-in widget.
];

const jwtErrors = [
  "The JWT expired and is no longer valid",
  "The JWT was issued in the future"
];

export function handleOktaSignInWidgetError (params: { error: any, context?: any }) {
  handleUserTimeSyncErrors(params.error);
  handleSessionClientMismatchErrors(params.error);

  if (!excludeErrorFromLog(params.error)) {
    log(params);
  }
}

const handleSessionClientMismatchErrors = (error: any) => {
  if (error.name !== "OAUTH_ERROR" || typeof error.message !== "string") {
    return;
  }

  const message = error.message.toLowerCase();
  const notifierStore = useNotifierStore();

  if (message === "user is not assigned to the client application.") {
    window.location.href = "#";
    notifierStore.setDanger("Unable to sign in. Please try again.");
  }
};

const handleUserTimeSyncErrors = (error: any) => {
  if (error.name !== "OAUTH_ERROR" || typeof error.message !== "string") {
    return;
  }

  const message = error.message.toLowerCase();
  const notifierStore = useNotifierStore();

  if (jwtErrors.some(e => e.toLowerCase() === message)) {
    window.location.href = "#";
    notifierStore.setDanger(
      "Unable to sign in. Please ensure that your device's time is in sync, then try again.");
  }
};

const excludeErrorFromLog = (error: any) => {
  const errorCode = _.get(error, "xhr.responseJSON.errorCode", "");
  return oktaErrorCodesToExcludeFromLog.includes(errorCode);
};

const log = (params: any) => {
  const dataToLog = params.error;

  if (params.context) {
    Object.assign(dataToLog, params.context);
  }

  const message = dataToLog.message
    ? `Error in Okta sign-in widget: ${dataToLog.message}`
    : "Error in Okta sign-in widget";

  const userStore = useUserStore();

  dataToLog.message = `${message} - Login username: ${userStore.username}`;
  dataToLog.userDate = Date.now();

  datadog.log(dataToLog.message, dataToLog, "info");
};